import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AarniGroupComponent} from "./aarni-group/aarni-group.component";
import {ActStatutesOrdinancesComponent} from "./act-statutes-ordinances/act-statutes-ordinances.component";
import {
    InnovationAndEnterpreneurshipComponent
} from "./innovation-and-enterpreneurship/innovation-and-enterpreneurship.component";
import {LeadershipComponent} from "./leadership/leadership.component";

const routes: Routes = [
    { path: 'about-us', component: AarniGroupComponent, data: {title: 'About Us'}},
    { path: 'core-values', component: AarniGroupComponent, data: {title: 'Core Values'}},
    { path: 'mission-and-vision', component: AarniGroupComponent , data: {title: 'Mission And Vision'}},
    { path: 'leadership/chancellor', component: LeadershipComponent, data: {title: 'Chancellor'}},
    { path: 'leadership/osd', component: LeadershipComponent, data: {title: 'Director Operations'}},
    { path: 'leadership/vice-chancellor', component: LeadershipComponent, data: {title: 'Vice Chancellor'}},
    { path: 'leadership/pro-vice-chancellor', component: LeadershipComponent, data: {title: 'Pro Vice Chancellor'}},
    { path: 'leadership/registrar', component: LeadershipComponent, data: {title: 'Registrar'}},
    { path: 'leadership/dean-r-and-d', component: LeadershipComponent, data: {title: 'Dean R & D'}},
    { path: 'leadership/dean-academic-affairs', component: LeadershipComponent, data: {title: 'Dean Academic Affairs'}},
    { path: 'faculty', component: AarniGroupComponent, data: {title: 'Faculty'}},
    { path: 'history', component: AarniGroupComponent, data: {title: 'History'}},
    { path: 'advisory-board', component: AarniGroupComponent, data: {title: 'Advisory Board'}},
    { path: 'work-at-arni', component: AarniGroupComponent, data: {title: 'Work At Arni'}},
    { path: 'government-affiliations', component: AarniGroupComponent, data: {title: 'Government Affiliations'}},
    { path: 'statutory-bodies-of-the-university', component: AarniGroupComponent, data: {title: 'Statutory Bodies Of The University'}},
    { path: 'arni-tenders', component: AarniGroupComponent, data: {title: 'Arni Tenders'}},
    { path: 'ai-integrated-program', component: AarniGroupComponent, data: {title: 'Ai Integrated Program'}},
    { path: 'act-statutes-ordinances', component: ActStatutesOrdinancesComponent, data: {title: 'Act, Statutes and Ordinances'}},
    { path: 'organizational-structure', component: ActStatutesOrdinancesComponent, data: {title: 'Organizational Structure'}},
    { path: 'rti', component: ActStatutesOrdinancesComponent, data: {title: 'RTI'}},
    { path: 'best-practice', component: ActStatutesOrdinancesComponent, data: {title: 'Best Practices'}},
    { path: 'analytical-center', component: ActStatutesOrdinancesComponent, data: {title: 'Analytical Center'}},
    { path: 'approvals', component: AarniGroupComponent, data: {title: 'Approvals'}},
    { path: 'innovation-and-entrepreneurship', component: InnovationAndEnterpreneurshipComponent, data: {title: 'Innovation and Entrepreneurship'}},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AboutRoutingModule { }
